import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";
import ContactUsBox from "../ContactUs";

function BlindfoldInfo() {
  return (
    <Container
      maxW="container.md"
      px={{ base: 4, md: 6 }} // Responsive padding
      py={{ base: 2, md: 4 }}
      bg={useColorModeValue("white", "gray.700")} // Light & Dark mode support
      borderRadius="lg"
      boxShadow="lg"
    >
      {/* Main Heading */}
      <Heading size="lg" textAlign="center" mb={4}>
        Blindfold Capital
      </Heading>

      {/* Description */}
      <VStack spacing={3} align="stretch">
        <Text fontSize={{ base: "sm", md: "md" }} textAlign={{ base: "left", md: "justify" }}>
          Blindfold Capital is a cutting-edge decentralized finance (DeFi) application designed to
          revolutionize the management of cryptocurrency positions on perpetual options exchanges.
          Built on the Arbitrum blockchain, Blindfold Capital leverages advanced automation and
          smart contract technology to create a fully transparent, secure, and self-sustaining
          trading ecosystem.
        </Text>

        <Text fontSize={{ base: "sm", md: "md" }} textAlign={{ base: "left", md: "justify" }}>
          At the core of Blindfold Capital is a custom SmartContract wallet, secured by a
          multi-signature framework with three EVM wallet keys or owners. This architecture ensures
          enhanced security and control while seamlessly interfacing with on-chain trading pools.
          By automating asset management and trade execution, the platform eliminates the
          complexities of manual trading, allowing users to engage in sophisticated options
          strategies with minimal intervention.
        </Text>

        <Text fontSize={{ base: "sm", md: "md" }} textAlign={{ base: "left", md: "justify" }}>
          Blindfold Capital's proprietary trading infrastructure continuously monitors token prices,
          account balances, and exchange positions in real time. Advanced technical analysis
          algorithms process a wide range of market indicators, generating a composite trend signal
          that dynamically adjusts trading parameters. This adaptive approach enables the platform
          to optimize risk exposure, capitalize on market opportunities, and maintain an efficient,
          algorithm-driven trading protocol.
        </Text>
      </VStack>

      {/* Contact Us Section */}
      <Center mt={6}>
        <ContactUsBox />
      </Center>
    </Container>
  );
}

export default BlindfoldInfo;
